module.exports = __webpack_public_path__ + "img/logo-agilimo.03080b4b.svg";